//@flow
import { Platform } from "react-native";

let PlatformOS = {
  Android: Platform.OS !== "ios",
  iOS: Platform.OS === "ios"
};

export { PlatformOS };
